import styled from 'styled-components';
import { spacing } from '@nubank/nuds-web/styles/themeUtils';

export const ExperimentsWidgetToggle = styled.button`
  width: ${spacing('12x')};
  height: ${spacing('12x')};
  background-color: black;
  position: fixed;
  bottom: 0;
  right: ${spacing('4x')};
  z-index: 3001;
  border-top-right-radius: ${spacing('1x')};
  border-top-left-radius: ${spacing('1x')};
  cursor: pointer;
`;
